
<template>
  <div class="columns is-centered">
    <div class="column is-7">
      <div class="box is-light">
        <div class="columns is-mobile head1 is-gant" style="border-radius: 5px">
          <div class="column" style="text-align: center">
            <h1 class="title is-4" style="color: white">
              <b-icon icon="file"> </b-icon> Assign Travel Policy
            </h1>
          </div>
        </div>

        

        <div v-if="loading">
          <b-loading
            :is-full-page="false"
            :active="loading"
            :can-cancel="true"
          ></b-loading>
        </div>
        <div>
           

          <div v-if="!loading && contacts.length > 0">
              <b-field grouped group-multiline   style="float: right">
            <b-button v-if="checkedRows.length>0"
                label="Clear checked"
                type="is-danger"
                icon-left="close"
                class="field"
                :disabled="checkedRows.length<1"

                @click="checkedRows = []" />
<b-tooltip label="Select one or more contacts and click Assign Travel Policy to choose travel policy"
            position="is-bottom"
            :animated="false">
            <b-button
                label="Assign Travel Policy"
              class="button is-primary"
          :disabled="checkedRows.length<1"
                @click="showAssignPolicyPrompt" />
                        </b-tooltip>

        </b-field>
        <br><br>

            <b-table :data="contacts" ref="table" detail-key="id"
              :checked-rows.sync="checkedRows"
                    hoverable
                    checkable
                   :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :pagination-rounded="isPaginationRounded"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :narrowed="isNarrowed"
            default-sort="name">
           
<template v-for="column in columns">
                <b-table-column :key="column.id" v-bind="column">
                    <template
                        v-if="column.searchable && !column.numeric"
                        #searchable="props">
                        <b-input
                            v-model="props.filters[props.column.field]"
                            placeholder="Search..."
                            icon="magnify"
                            size="is-small" />
                    </template>
                    <template v-slot="props">
                        {{ props.row[column.field] }}
                    </template>
                     </b-table-column>
            </template>
            <b-table-column
                  v-slot="props"
                >
                 <span v-if="props.row.tripCircultPolicyId">
                      

                  <a @click="deletePolicy(props.row.id)"> <b-icon
                icon="delete"
                size="is-small">
            </b-icon></a>
                 </span>

                </b-table-column>


              <template #empty>
                <div class="has-text-centered">No contacts found</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import AssignTravelPolicyModal from './AssignTravelPolicyModal.vue';

    export default {
      name: 'AssignTravelPolicy',
      data: function () {
        return {
            loading: true,
            contacts:[],
                      policies:[],
             checkedRows: [],
                 isPaginated: true,
                isPaginationSimple: false,
                isPaginationRounded: false,
                paginationPosition: 'bottom',
                defaultSortDirection: 'asc',
                sortIcon: 'arrow-up',
                sortIconSize: 'is-small',
                currentPage: 1,
                perPage: 20,
                isNarrowed:false,
                columns: [
                {
                    field: 'id',
                    label: 'ID',
                    searchable: false,
                    visible:false
                },
                {
                    field: 'name',
                    label: 'Name',
                    searchable: true,
                    sortable:true
                },
                {
                    field: 'email',
                    label: 'Email',
                    searchable: true,
                     sortable:true

                },
                {
                    field: 'tripCircultPolicyName',
                    label: 'Travel Policy',
                    centered: true,
                    searchable: false,
                                        sortable:true


                },
                 {
                    field: 'tripCircultPolicyId',
                    label: 'Travel Policy Id',
                     searchable: false,
                    visible:false


                }
            ]
             
        }
    },
      computed: {
        activeUser() {
          return this.$store.getters['app/getActiveUser'];
        },
        isTravelChampion(){
          if(this.activeUser)
            return this.activeUser.isTravelChampion;
          return false;
        },
        selectedContacts(){
            
    const result = this.checkedRows.map(item => item.id);


    return result;

        }
      },
      methods: {
        deletePolicy(contactId){

          var deletedContacts=[];
          deletedContacts.push(contactId);

           this.$buefy.dialog.confirm({
                    title: 'Unassigning Travel Policy',
                    message: 'Are you sure you want to unassign travel policy for this contact?',
                    confirmText: 'Yes',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>{
                      this.loading=true;
                         var body = {
            "accountId": this.activeUser.account.id,
            "contactId":this.activeUser.id,
            "travelPolicyId":'',
            "listOfContacts":deletedContacts
            }
            this.$app.huddleLabsServerCall('profile/assign-travel-policy', body)
            .then(result => {
                if(result.success){
                    this.loading=false;
                    this.getContacts();
                    

                }else{
                    this.failure();
                    this.loading=false;

                }

            })
                    }
                })

        },
     
        getContacts() {
          this.loading=true;
          var body = {"accountId": this.activeUser.account.id,"contactId":this.activeUser.id}
          this.$app.huddleLabsServerCall('profile/contacts', body)
            .then(response => {this.contacts = response.data;
            this.loading=false;
            })
        },
         getPolicy() {
          this.loading=true;
          var body = {
            accountId: this.activeUser.account.id,
            contactId: this.activeUser.id,
            includeDetails: false 
          }
          this.$app.huddleLabsServerCall('profile/travel-policy/list', body)
            .then(response => {this.policies = response.data;
            this.loading=false;
            })
        },
        showAssignPolicyPrompt(){
            this.$buefy.modal.open({
                    parent: this,
                    component: AssignTravelPolicyModal,
                    hasModalCard: true,
                    customClass: '',
                    trapFocus: true,
                     props: {
                        selectedContacts:this.selectedContacts,
                        policies:this.policies
            },
            events:{
               'save-success':()=>{
                   this.checkedRows = []
              this.getContacts();
               }
               }
        })
        }
      
      },
      mounted () {
              this.getContacts();
              this.getPolicy();
      }
    }
</script>


